// import firebase from "@/generic_api/firebase/firebase";
// import { firebaseAction } from "vuexfire";
// import queries from "@/store/queries";
//import moment from '@/moment-gp.js';
//import * as log from "loglevel";

export default {

  // Also include sign up!

  /* TODO: Replace with generic API */
  // setUserRef: firebaseAction(({ bindFirebaseRef, getters, commit }, ref) => {
  //   console.warn('DEPRECATED');
  //   // console.log("Binding user to ", ref);
  //   bindFirebaseRef("userData", ref).then(x => {
  //
  //     /* HACK: save user profilePic to Realtime DB so other users get a preview
  //       while searching. This can not be done in auth.js since the userData is
  //       not available */
  //     let profilePic = getters.get_profile_pic << !!
  //     let currentUser = firebase.auth().currentUser;
  //
  //     const oldRealTimeDb = firebase.database();
  //     oldRealTimeDb
  //       .ref("/status/" + currentUser.uid)
  //       .update({
  //         profilePic
  //       });
  //   })
  // }),

  // fetchUserList({ commit }) {
  //   console.warn('DEPRECATED');
  //   // TODO: This is very expensive on the database
  //   // TODO: Also this probably won't work when there is a lot of users
  //
  //   let promises = [];
  //   let list = [];
  //
  //   queries
  //     .allUsersCollection()
  //     .get()
  //     .then(function(querySnapshot) {
  //       querySnapshot.forEach((doc) => {
  //
  //         /* TODO: move to quries */
  //         /* HACK: Load all users in the database */
  //         promises.push(queries
  //           .userPrivateDocumentQuery(doc.id)
  //           .get()
  //           .then((doc2) => {
  //             list.push({
  //               id: doc.id,
  //               academicTitle: doc2.data().academicTitle,
  //               firstName: doc2.data().firstName,
  //               lastName: doc2.data().lastName,
  //               email: doc2.data().email
  //             });
  //             return doc2.id;
  //           }));
  //     })
  //
  //     Promise.all(promises)
  //       .then(values => {
  //         console.log("All users fetched.", values, list);
  //         commit("SET_USER_LIST", list);
  //       }).catch(err => {
  //         console.log("Failed to fetch user user", err);
  //       })
  //   })
  //   .catch(err => {
  //     console.log("Failed to fetch user userlist", err);
  //   })
  // },

  // toggleSidebar({ commit, state }) {
  //   console.warn('DEPRECATED');
  //   commit("TOGGLE_SIDEBAR");
  // },

  // user_updateOnlineStatus(context, { isOnline }) {
  //   console.warn('DEPRECATED');
  //   /* TWE: sollte das nicht eher in user/index.js, da user spezifisch nicht contact spezifisch? */
  //   /* TWE: contact_ weglasen? */
  //   let userId = context.rootGetters["user/userAuth"].id;
  //   console.log("Update User (" + userId + ") online status: " + isOnline);
  //
  //   if (userId && (isOnline === "online" || isOnline === "offline")) {
  //     var data = {};
  //     if (isOnline === "online") {
  //       data = {
  //         online: true
  //       };
  //     } else {
  //       data = {
  //         online: false
  //       };
  //     }
  //
  //     //let payload = {};
  //     //payload[``] = data; /* TWE: ACHTUNG "}" */
  //     queries.contacts[userId].update(data);
  //   }
  // },

  // user_updateUsernameInStatus(context, { username }) {
  //   console.warn('DEPRECATED');
  //   /* TWE: sollte das nicht eher in user/index.js, da user spezifisch nicht contact spezifisch? */
  //   /* TWE: contact_ weglasen? */
  //   let userId = context.rootGetters["user/userAuth"].id;
  //   console.log("Update User (" + userId + ") username to " + username);
  //
  //   if (userId && username && username !== '') {
  //     var data = {};
  //       data = {
  //         'username': username
  //       };
  //
  //     //let payload = {};
  //     //payload[`username`] = username; /* TWE: ACHTUNG "}" */
  //     queries.contacts[userId].update(data);
  //   }
  // },

 //  /*
 //  Create new workspace for project, so that
 //  */
 //  user_create_workspace_for_project(context, { projectId } ) {
 //    console.warn('DEPRECATED');
 //    var payload = {};
 //    var data = { showFinished: true }
 //    payload[`projects.${projectId}.workspace`] = data;
 //    queries.user.update(payload);
 //  },
 // /*
 // projects: ObjectArray with projects uuid [required]
 //    name: String [required]
 //    workspace:  Object
 //      contacts: ObjectArray with contact uuids [required]
 //        posX: Number
 //        posY: Number
 //        collapsed: Boolean
 //        */
 //  user_set_project_workspace_contact(context, { projectId, contactId }) {
 //    console.warn('DEPRECATED');
 //    console.log("Adding contact " + contactId + " to workspace of project " + projectId);
 //      let data = {
 //        position: {
 //          posX: 100,
 //          posY: 0
 //        },
 //        visible: true,
 //        collapsed: false
 //    };
 //    var payload = {};
 //    if ( projectId && projectId !== -1 ) {
 //      payload[`projects.${projectId}.workspace.${contactId}`] = data; /* TWE: ACHTUNG "}" */
 //      queries.user.update(payload);
 //    }
 //  },
 //  /*
 //  Update avatar position on canvas
 //  */
 //  user_update_project_workspace_contact_position({ getters }, { projectId, contactId, posX, posY }) {
 //    console.warn('DEPRECATED');
 //    /* TODO */
 //    console.log("Updating Position for contact " + contactId + " in project " + projectId + " to " + posX + "/" + posY);
 //      let data = {
 //        posX: posX,
 //        posY: posY
 //    };
 //    var payload = {};
 //      payload[`projects.${projectId}.workspace.${contactId}.position`] = data; /* TWE: ACHTUNG "}" */
 //      queries.user.update(payload);
 //  },
 //
 //  /*
 //  update the variable in workspace that determines if finished tasks are visible on the sunburst
 //  */
 //  user_update_project_workspace_contact_showFinishedTasks({ getters }, { projectId, showFinished }) {
 //    console.warn('DEPRECATED');
 //    /* TODO */
 //    //console.log("Updating showFinished for project " + projectId + " to " + showFinished);
 //      /*let data = {
 //        showFinished: showFinished
 //    };*/
 //    var payload = {};
 //    payload[`projects.${projectId}.workspace.showFinished`] = showFinished; /* TWE: ACHTUNG "}" */
 //    queries.user.update(payload);
 //  },
 //
 //  /*
 //    Update status of collapes yes/no on canvas
 //    */
 //  user_update_project_workspace_contact_collapsed({ getters }, { projectId, contactId, collapsed }) {
 //    console.warn('DEPRECATED');
 //    console.log("Updating Collapsed status for contact " + contactId + " in project " + projectId + " to " + collapsed);
 //    var payload = {};
 //    payload[`projects.${projectId}.workspace.${contactId}.collapsed`] = collapsed; /* TWE: ACHTUNG "}" */
 //    queries.user.update(payload);
 //  },
 //
 //   /*
 //    Update user visibility on canvas
 //    */
 //  user_update_project_workspace_contact_visible({ getters }, { projectId, contactId, visible }) {
 //    console.warn('DEPRECATED');
 //    console.log("Updating visibility status for contact " + contactId + " in project " + projectId + " to " + visible);
 //    var payload = {};
 //    payload[`projects.${projectId}.workspace.${contactId}.visible`] = visible; /* TWE: ACHTUNG "}" */
 //    queries.user.update(payload);
 //  },

  // user_update_profile_info(context, userPayload) {
  //   console.warn('DEPRECATED');
  //   // console.log("user_update_profile_info", userPayload)
  //   // let userId = context.rootGetters["user/userAuth"].id;
  //   let allowedUpdatedUserDataFields = [
  //       'academicTitle',
  //       'firstName',
  //       'lastName',
  //       'jobTitle',
  //       'birthday',
  //       'settings.timezone',
  //       'settings.language',
  //       'address.address',
  //       'address.city',
  //       'address.zip',
  //       'address.phone',
  //       'address.country',
  //       'settings.dateformat',
  //       'deleted',
  //       'deleteDate' ];
  //
  //   var payload = {};
  //   var newUsername = '';
  //
  //   Object.keys(userPayload).map((key) => {
  //     if ( allowedUpdatedUserDataFields.includes(key) ) {
  //       payload[key] = userPayload[key];
  //     }
  //     if ( allowedUpdatedUserDataFields.includes('firstName') ) {
  //       newUsername = payload['firstName'];
  //     }
  //     if ( allowedUpdatedUserDataFields.includes('lastName') ) {
  //       newUsername = newUsername + ' ' + payload['lastName'];
  //     }
  //   })
  //
  //   console.log("user_update_profile_info", payload);
  //
  //   // update username in /user/{userid}/public/status
  //   if (newUsername !== '') {
  //     this.dispatch('user/user_updateUsernameInStatus', { username: newUsername });
  //   }
  //   // update userdata in /user/{userid}/private/userdata
  //   return queries.user.update(payload);
  // },

  // user_update_language(context, language) { /* user_update_locale? */
  //   console.warn('DEPRECATED');
  // },

  // user_update_profile_picture(context, { profilePicUrl }) {
  //   console.warn('DEPRECATED');
  //   // console.log("user_update_profile_picture", profilePicUrl)
  //   // let userId = context.rootGetters["user/userAuth"].id;
  //   //
  //   // let updateProfilePic = true;
  //   // let updateStatusPic = true;
  //   //
  //   // var payload = {};
  //   // if ( updateProfilePic ) {
  //   //   payload['profilePic'] = profilePicUrl;
  //   //   queries.user.update(payload);
  //   // }
  //   // if ( updateStatusPic ) {
  //   //   payload['img'] = profilePicUrl;
  //   //   queries.contactPublicDataQuery(userId).update(payload);
  //   // }
  // },

  /*user_update_timezone(context, {timezone}) {

    // update username in /user/{userid}/public/status
    if (timezone !== '' && moment.tz.zone(timezone)) { // only save valid timezones
      var payload = {};
      payload['timezone'] = timezone;
      queries.user.update(payload);
    }
    // update userdata in /user/{userid}/private/userdata
    return queries.user.update(payload);
  },/*

  /*
    Update user
    */
  /*
  update_user(context, { data, prefix }) {
    console.warn('DEPRECATED');
    console.log("update_user", data, prefix);

    const VALID_PREFIX = {
      'availabilitySettings': [
        'mode',
        'timeSpentAtJob',
        'timeSpendOtherwise',
        'hoursSleep',
        'weeklyCommitmentRate',
        'cachedHoursAvailable',
        'startTime',
        'endTime',
        'freeTimeMethod',
        'calendarFreeTimeMethod' ],
      'workmodeSettings': ['enabled','workDuration', 'breakDuration'],
      'connectionSettings': ['provider', 'apikey'],
      'backgroundSettings': ['image', 'color', 'displayPictureNotColor'],
      'visionboardSettings': [
        'canvasScaleMethod',
        'backgroundColor',
        'width',
        'height',
        'allHeadlinesFontSize',
        'allCommitmentsFontSize',
        'showAllCommitments',
        'showAllHeadlines',
        'showAllProgress',
        'customText',
        'groupItems' ],
      'selectedIdols': null,
      'selectedGoals': null
    };

    if ( !Object.keys(VALID_PREFIX).includes(prefix) ) {
      console.warn("invalid prefix!");
      return;
    }

    let VALID_FIELD_LIST = VALID_PREFIX[prefix]
    let payload = {};

    if ( VALID_FIELD_LIST == null ) {
      payload[`${prefix}`] = data;
    } else {
      Object.keys(data).forEach(key => {
        if ( VALID_FIELD_LIST.includes(key) ) {
          payload[`${prefix}.${key}`] = data[key];
        }
      });
    }
    console.log("update_user: submitting payload", payload);
    queries.user.update(payload);
  },
  */
};
